import React from "react";

const BellIcon = ({ theme }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5858 19.25C12.4247 19.5279 12.1934 19.7585 11.915 19.9188C11.6367 20.0791 11.3212 20.1635 11 20.1635C10.6788 20.1635 10.3633 20.0791 10.085 19.9188C9.80664 19.7585 9.57533 19.5279 9.41417 19.25M16.5 7.70004C16.5 6.14446 15.9207 4.65212 14.8894 3.55212C13.8582 2.45212 12.4575 1.83337 11 1.83337C9.5425 1.83337 8.14275 2.45121 7.11058 3.55212C6.07933 4.65212 5.5 6.14446 5.5 7.70004C5.5 14.5448 2.75 16.5 2.75 16.5H19.25C19.25 16.5 16.5 14.5448 16.5 7.70004Z"
        stroke={theme === "dark" ? "white" : "#122549"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BellIcon;
